<template>
    <div class="mb-4">
        <b-form-fieldset>
            <b-row>
                <b-col sm="6">
                    <b-card>
                        <h4 class="strong">Basic Data (Required)</h4>
                        <hr />
                        <b-row class="mb-2" v-for="label in labels" v-bind:key="label[1]">
                            <label class="col-sm-4 col-form-label single-line">{{ label[0] }}</label>
                            <b-form-input class="col-sm-6" v-model="inputs[label[1]]" @blur="checkIfNumber(label[1])"></b-form-input>
                            <label v-if="label[2] == 'TVD'" class="col-sm-2 col-form-label single-line">{{ unit }} {{ label[2] }}</label>
                            <label v-else-if="label[2] == '#'" class="col-sm-2 col-form-label single-line">{{ unit }}</label>
                            <label v-else class="col-sm-2 col-form-label single-line">{{ label[2] }}</label>
                        </b-row>
                    </b-card>
                    <b-card class="mt-4">
                        <h4 class="strong">Basic Data (Optional)</h4>
                        <hr />
                        <b-row class="mb-2" v-for="label in labelsOptional" v-bind:key="label[1]">
                            <label class="col-sm-4 col-form-label single-line">{{ label[0] }}</label>
                            <b-form-input class="col-sm-6" v-model="inputs[label[1]]" @blur="checkIfNumber(label[1])"></b-form-input>
                            <label v-if="label[2] == 'TVD'" class="col-sm-2 col-form-label single-line">{{ unit }} {{ label[2] }}</label>
                            <label v-else class="col-sm-2 col-form-label single-line">{{ label[2] }}</label>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col sm="6">
                    <b-card>
                        <h4 class="strong">API / Sgo</h4>
                        <hr />
                        <b-row>
                            <b-col md="6">
                                <b-input-group prepend="API">
                                    <b-form-input type="number" step="any" v-model="inputs.api" @change="didChangeApi()"></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col md="6">
                                <b-input-group prepend="Sgo">
                                    <b-form-input type="number" step="any" v-model="inputs.sgo" @change="didChangeSgo()"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-form-text>(Required) Fill either API or Sgo. The other field will be automatically calculated.</b-form-text>
                    </b-card>
                    <b-card class="mt-4">
                        <h4 class="strong">Casing & Tubing</h4>
                        <hr />
                        <b-row class="mb-2">
                            <label class="col-sm-4 col-form-label single-line">Casing Size</label>
                            <b-form-select class="col-sm-6" v-model="inputs.caseSize" :options="optCaseSize" @change="didChangeCasing"></b-form-select>
                        </b-row>
                        <b-row class="mb-2">
                            <label class="col-sm-4 col-form-label single-line">Casing ID</label>
                            <b-form-select class="col-sm-6" v-model="inputs.caseId" :options="optCaseId[inputs.caseSize]"></b-form-select>
                            <label class="col-sm-2 col-form-label single-line">inch</label>
                        </b-row>
                        <b-row class="mb-2">
                            <label class="col-sm-4 col-form-label single-line">Tubing Size</label>
                            <b-form-select class="col-sm-6" v-model="inputs.tubeSize" :options="optTubeSize" @change="didChangeTubing"></b-form-select>
                        </b-row>
                        <b-row class="mb-2">
                            <label class="col-sm-4 col-form-label single-line">Tubing ID</label>
                            <b-form-select class="col-sm-6" v-model="inputs.tubeId" :options="optTubeId[inputs.tubeSize]"></b-form-select>
                            <label class="col-sm-2 col-form-label single-line">inch</label>
                        </b-row>
                        <b-row>
                            <label class="col-sm-4 col-form-label single-line">Tubing Coefficient</label>
                            <b-form-select class="col-sm-6" v-model="inputs.tubeCoeff" :options="optTubeCoeff"></b-form-select>
                        </b-row>
                    </b-card>
                    <b-card class="mt-4">
                        <h4 class="strong">Liner</h4>
                        <hr />
                        <b-alert variant="info" show>
                            <b-form-text style="color: black !important">
                                Liner data are optional, but if inserted, will be subject to further validation with casing and tubing.
                            </b-form-text>
                        </b-alert>
                        <b-row class="mb-2" v-for="label in labelsLiner" v-bind:key="label[1]">
                            <label class="col-sm-4 col-form-label single-line">{{ label[0] }}</label>
                            <b-form-input class="col-sm-6" v-model="inputs[label[1]]" @input="checkIfEmpty(label[1])" @blur="checkIfNumber(label[1])"></b-form-input>
                            <label v-if="label[2] == 'TVD'" class="col-sm-2 col-form-label single-line">{{ unit }} {{ label[2] }}</label>
                            <label v-else class="col-sm-2 col-form-label single-line">{{ label[2] }}</label>
                        </b-row>
                    </b-card>
                    <b-card class="mt-4">
                        <b-alert variant="info" :show="infos != ''">
                            <strong>Information</strong>
                            <b-form-text style="color: black !important">
                                {{ infos }}
                            </b-form-text>
                        </b-alert>
                        <b-alert variant="warning" :show="warnings != ''">
                            <strong>Warning!</strong>
                            <b-form-text style="color: black !important">
                                {{ warnings }}
                            </b-form-text>
                        </b-alert>
                        <b-alert variant="danger" :show="errors != ''">
                            <strong>Saving not allowed</strong>
                            <b-form-text style="color: black !important">
                                {{ errors }}
                            </b-form-text>
                        </b-alert>
                        <b-row> 
                            <b-col sm="12" style="text-align: end">
                                <b-btn variant="primary" :disabled="errors != ''" @click="didTapSave">{{ saveButtonLabel }}&ensp;<font-awesome-icon icon="arrow-alt-circle-right" /></b-btn>
                            </b-col>    
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-form-fieldset>
    </div>
</template>

<script>
export default {
    name: "data-input",
    data() {
        return {

            labels: [
                ["Top Perfo", "topPerfo", "TVD"],
                ["Top Perfo", "topPerfom", "m MD"],
                ["Bottom Perfo", "bottomPerfo", "TVD"],
                 ["Bottom Perfo", "bottomPerfom", "m MD"],
                ["Qtest", "qTest", "BPD"],
                ["SBHP", "sbhp", "psig"],
                ["FBHP", "fbhp", "psig"],
                ["Producing GOR", "pGOR", "scf/stb"],
                ["WC", "wc", "%"],
                ["BHT", "bht", "°F"],
                ["SGw", "sgw", ""],
                ["SGg", "sgg", ""],
                ["Qdes", "qDes", "BPD"],
                ["PSD", "psd", "TVD"],
                ["WHP", "whp", "psig"],
                ["PSD(m MD)","psdmd", "m MD"]
            ],

            labelsOptional: [
                ["P. Casing", "cp", "psi"],
                ["Pb", "pb", "psig"]
            ],

            labelsLiner: [
                ["Liner ID", "linerOD", "inch"],
                ["Top Liner at", "topLiner", "TVD"],
                ["Bottom Liner at", "botLiner", "TVD"]
            ],

            selections: [
                ["Casing Size", "caseSize", ""],
                ["Casing ID", "caseId", "inch"],
                ["Tubing Size", "tubeSize", ""],
                ["Tubing ID", "tubeId", "inch"],
                ["Tubing Coefficient", "tubeCoeff", ""]
            ],

            inputs: {
                topPerfo: null,
                topPerfom: null,
                bottomPerfo: null,
                bottomPerfom: null,
                qTest: null,
                sbhp: null,
                fbhp: null,
                cp: null, 
                pGOR: null,
                wc: null,
                api: null,
                bht: null,
                sgw: null,
                sgg: null,
                sgo: null,
                pb: null,
                qDes: null,
                psd: null,
                whp: null,
                linerOD: null,
                topLiner: null,
                botLiner: null,
                sfl: null,
                dfl: null,
                caseSize: 5.5,
                caseId: 5.012,
                tubeSize: 2.875, //2.375,
                tubeId: 2.441, //2.041,
                tubeCoeff: "New Tubing"
            },

            // Options
            optCaseSize: [5.5, 6.625, 7, 9.625, 12],
            optCaseId: {
                5.5: [5.044, 5.012, 4.950, 4.892, 4.778, 4.670, 4.548, 4.440, 4.376, 4.276, 4.090, 4.044],
                6.625: [6.135, 6.049, 5.921, 5.791, 5.675, 5.575, 5.375, 4.375],
                7: [6.538, 6.456, 6.366, 6.276, 6.184, 6.094, 6.004, 5.920, 5.820, 5.750, 5.720, 5.660, 5.540, 5.376, 5.240, 5.040],
                9.625: [9.063, 9.001, 8.921, 8.885, 8.835, 8.755, 8.681, 8.535, 8.435, 8.407, 8.375, 8.281, 8.157, 8.125],
                12: [12.02, 12.06]
            },
            optTubeSize: [2.375, 2.875, 3.5],
            optTubeId: {
                2.375: [1.867, 1.995, 2.041],
                2.875: [2.259, 2.441],
                3.5: [2.750, 2.992, 3.068]
            },
            optTubeCoeff: ["New Tubing", "Old Tubing"],

            // Misc
            saveButtonLabel: "Save & Continue",
            isSaving: false,
            unit: ""

        }
    },
    computed: {

        infos() {

            let info = ""

            if(this.inputs.topLiner != null && (this.inputs.psd > this.inputs.topLiner)) {
                info = "Setting Depth is below the Liner."
            }

            return info

        },

        warnings() {

            let warnings = ""

            if(this.inputs.linerOD != null) {

                if(this.inputs.linerOD > this.inputs.caseId) {
                    warnings = "Liner ID is greater than Casing ID. "
                }

            }

            return warnings

        },

        errors() {

            // Required inputs
            let optionalKeys = ["pb", "linerOD", "topLiner", "botLiner", "cp"]

            if(this.$core.general.instrument == "Sonolog") {
                optionalKeys.push("sbhp")
                optionalKeys.push("fbhp")
            }
            else {
                optionalKeys.push("sfl")
                optionalKeys.push("dfl")
            }

            for(var key in this.inputs) {

                // Skips optional keys check
                if(optionalKeys.includes(key)) { 
                    continue
                }

                if(this.inputs[key] == null || this.inputs[key] == "") { 
                    return "Empty required field(s) found!" 
                }

            }

            // 5.012 constraint
            let constraint = 0
            let by = ""

            if(this.inputs.linerOD != null && this.inputs.topLiner != null && this.inputs.psd > this.inputs.topLiner) {
                constraint = this.inputs.linerOD
                by = "Liner ID"
            }
            else {
                constraint = this.inputs.caseId
                by = "Casing ID"
            }

            if(constraint < 5.012) {
                return `${by} must not be lower than 5.012!`
            }

            // All validation passed.
            return ""

        }

    },
    methods: {

        didChangeApi() {
            this.inputs.sgo = this.roundify(141.5 / (131.5 + +this.inputs.api))
        },

        didChangeSgo() {
            this.inputs.api = this.roundify((141.5 - (131.5 * this.inputs.sgo)) / this.inputs.sgo)
        },

        didChangeCasing() {
            let caseSize = this.inputs.caseSize
            if(caseSize == 5.5) this.inputs.caseId = 5.012
            else if(caseSize == 7) this.inputs.caseId = 6.538
            else if(caseSize == 9.625) this.inputs.caseId = 8.921
        },

        didChangeTubing() {
            let tubeSize = this.inputs.tubeSize
            if(tubeSize == 2.375) this.inputs.tubeId = 2.041
            else if(tubeSize == 2.875) this.inputs.tubeId = 2.441
            else if(tubeSize == 3.5) this.inputs.tubeId = 2.992
        },

        checkIfNumber(key) {
            if(isNaN(this.inputs[key])) {
                this.inputs[key] = null
            }
            // if(this.inputs[key] == "") {
            //     this.inputs[key] = null
            // }
        },
        
        checkIfEmpty(key) {
            if(this.inputs[key] == "") {
                this.inputs[key] = null
            }
        },

        roundify(input) {
            if(Number.isInteger(input)) {
                return input
            }
            else {
                return input.toFixed(3)
            }
        },

        didTapSave() {

            // Check for ID constraint - prompt user if TG variants will be disallowed
            var constraint = 0

            if(this.inputs.linerOD != null && this.inputs.topLiner != null && this.inputs.psd > this.inputs.topLiner) {
                constraint = this.inputs.linerOD
            }
            else {
                constraint = this.inputs.caseId
            }

            var isConflicting = false
            if(this.$core.idConstraint >= 5.92 && constraint < 5.92) {

                // Check if user is using a TG/540s-variant equipments
                if("graph" in this.$core.pump) {

                    if(this.$core.pump.graph.graph.pump.startsWith("TG")) {
                        isConflicting = true
                    }

                }

                let eq = this.$core.equipment
                if(eq != null && "motor1" in this.$core.equipment) {

                    if(
                        eq.motor1[4] == "540s"
                        || eq.gasSeparator.endsWith("540s")
                        || eq.gasHandler.startsWith("540s")
                        || eq.protector1.endsWith("540s")
                    ) {
                        isConflicting = true
                    }

                }

                if(isConflicting) {
                    let confirmed = confirm(`Your new Casing & Liner ID settings will not allow the use of TG pump & 540s equipment variants.\n\nIf you wish to continue, the 'Pump Selection' and 'Equipment Selection' will be reset.\n\nDo you wish to continue?`)
                    if(!confirmed) { return }
                }

            }

            let payload = {
                calculationId: this.$core.id,
                inputs: this.inputs,
                shouldReset: isConflicting
            }

            this.isSaving = true
            this.saveButtonLabel = "Processing..."
            this.$axios.post("/calc/dataInput", payload).then(response => {

                this.saveButtonLabel = "Save & Continue"
                let res = response.data

                if(res.message == "OK") {
                    this.$core.dirtyInput = this.inputs
                    this.$core.input = this.inputs
                    this.$core.output = res.data.output
                    this.$core.idConstraint = constraint

                    // Resets the core data if needed
                    if(isConflicting) {
                        this.$core.pump = {}
                        this.$core.equipment = {}
                        this.$router.app.$emit("disableTab", 4)
                    }

                    this.$router.app.$emit("enableTab", 2)
                    this.$router.app.$emit("enableTab", 3)

                    this.$router.push("/input/ipr-curve")
                }
                else {
                    this.$helper.toastError(this, res.message)
                }

            })
            .catch(error => {
                this.$helper.toastError(this, error)
            })
            .finally(() => {
                this.isSaving = false
            })

        }

    },
    created: function() {

        this.$router.app.$emit("changeTab", "data-input")

        // Change the labels if the type is Sonolog
        if(this.$core.general.instrument == "Sonolog") {
            this.$set(this.labels, 3, ["SFL", "sfl", "#"])
            this.$set(this.labels, 4, ["DFL", "dfl", "#"])
        }
        
        if(this.$core.dirtyInput != null && "qTest" in this.$core.dirtyInput) {
            this.inputs = this.$core.dirtyInput
        }

        this.unit = this.$core.general.unit

    },
    beforeRouteLeave(to, from, next) {

        this.$core.dirtyInput = JSON.parse(JSON.stringify(this.inputs))
        next()

    }
}
</script>

<style>

    .strong {
        margin-bottom: 0;
    }

    .single-line {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

</style>